/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetHistoryProgrammerRequest = { month: number; day: number };

export const GetHistoryProgrammerRequest$zodSchema: z.ZodType<
  GetHistoryProgrammerRequest
> = z.object({
  day: z.int().describe("日期，1-31之间的整数。"),
  month: z.int().describe("月份，1-12之间的整数。"),
});

/**
 * 服务器内部错误。
 */
export type GetHistoryProgrammerInternalServerErrorResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetHistoryProgrammerInternalServerErrorResponseBody$zodSchema:
  z.ZodType<GetHistoryProgrammerInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
  }).describe("服务器内部错误。");

/**
 * 请求参数错误。请检查月份和日期参数是否正确。
 */
export type GetHistoryProgrammerBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetHistoryProgrammerBadRequestResponseBody$zodSchema: z.ZodType<
  GetHistoryProgrammerBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("请求参数错误。请检查月份和日期参数是否正确。");

export type GetHistoryProgrammerEvent = {
  year?: number | undefined;
  title?: string | undefined;
  description?: string | undefined;
  category?: string | undefined;
  importance?: number | undefined;
  relevance_score?: number | undefined;
  url?: string | undefined;
};

export const GetHistoryProgrammerEvent$zodSchema: z.ZodType<
  GetHistoryProgrammerEvent
> = z.object({
  category: z.string().optional(),
  description: z.string().optional(),
  importance: z.int().optional(),
  relevance_score: z.number().optional(),
  title: z.string().optional(),
  url: z.string().optional(),
  year: z.int().optional(),
});

/**
 * 获取成功！返回指定日期的程序员历史事件列表。
 */
export type GetHistoryProgrammerResponseBody = {
  message?: string | undefined;
  date?: string | undefined;
  events?: Array<GetHistoryProgrammerEvent> | undefined;
};

export const GetHistoryProgrammerResponseBody$zodSchema: z.ZodType<
  GetHistoryProgrammerResponseBody
> = z.object({
  date: z.string().optional(),
  events: z.array(z.lazy(() => GetHistoryProgrammerEvent$zodSchema)).optional(),
  message: z.string().optional(),
}).describe("获取成功！返回指定日期的程序员历史事件列表。");

export type GetHistoryProgrammerResponse =
  | GetHistoryProgrammerResponseBody
  | GetHistoryProgrammerBadRequestResponseBody
  | GetHistoryProgrammerInternalServerErrorResponseBody;

export const GetHistoryProgrammerResponse$zodSchema: z.ZodType<
  GetHistoryProgrammerResponse
> = z.union([
  z.lazy(() => GetHistoryProgrammerResponseBody$zodSchema),
  z.lazy(() => GetHistoryProgrammerBadRequestResponseBody$zodSchema),
  z.lazy(() => GetHistoryProgrammerInternalServerErrorResponseBody$zodSchema),
]);
